module.exports = __webpack_public_path__ + "static/media/06.8c28f4ca.webp";